import { AUTOSUGGEST_CLEAR } from 'redux/modules/auto-suggest/actions/types';

const autoSuggestClear = () => ({ type: AUTOSUGGEST_CLEAR });

export default autoSuggestClear;
